<!--
 * @Author: wsx
 * @Date: 2022-01-14 10:26:06
 * @LastEditTime: 2022-06-13 12:03:18
 * @LastEditors: zhangyaowen zhangyaowen_520@163.com
 * @Description: 巡防员表单
-->
<template>
  <el-dialog
    v-model="dialogVisible"
    :title="
      dialogStatus == '1'
        ? '新增巡防'
        : dialogStatus == '2'
        ? '编辑巡防'
        : '巡防详情'
    "
    width="60vw"
    @close="mapDialogClose(formRef)"
  >
    <el-form
      ref="formRef"
      :inline="true"
      :rules="rules"
      :model="tableParams"
      :disabled="dialogStatus == '3'"
      class="form-box"
    >
      <el-form-item label="巡防名称" prop="patrolmanName">
        <el-input
          v-model="tableParams.patrolmanName"
          placeholder="巡防名称"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item
        label="巡防线颜色"
        style="width: 200px"
        prop="patrolmanColor"
      >
        <el-select
          v-model="tableParams.patrolmanColor"
          clearable
          placeholder="不限"
        >
          <el-option
            v-for="item in colorList"
            :key="item.code"
            :label="item.value"
            :value="item.remark"
          >
            <div class="colorItem">
              <div
                class="carColor"
                :style="{ backgroundColor: item.remark }"
              ></div>
              <span>{{ item.value }}</span>
            </div>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="巡防类型" prop="patrolmanType">
        <h-button
          v-for="item in patrolList"
          :key="item.id"
          :disabled="drawAgainBtn"
          @click="getPatrolmanType(item.code)"
          :class="{ activeStyle: item.code == activeNum }"
          >{{ item.remark }}</h-button
        >
      </el-form-item>
      <el-form-item label="" style="margin-left: 30px">
        <h-button @click="getPointTable">巡防点列表</h-button>
      </el-form-item>
      <el-form-item label="巡防描述" style="width: 50%">
        <el-input
          v-model="tableParams.patrolmanDescribe"
          type="textarea"
          :autosize="{ minRows: 1, maxRows: 2 }"
          maxlength="50"
          show-word-limit
          clearable
          placeholder="巡防描述"
        ></el-input>
      </el-form-item>
    </el-form>

    <div class="map-box" v-if="dialogVisible">
      <!-- :features="mapFeatures" -->
      <my-map ref="mapRef" @draw-area="drawArea" @click-map="clickMap"></my-map>
    </div>
    <template #footer v-if="dialogStatus != '3'">
      <span class="dialog-footer">
        <h-button @click="mapDialogClose(formRef)">取消</h-button>
        <h-button @click="saveMapPoint(formRef)">提交</h-button>
      </span>
    </template>
    <patrolPointTable
      v-model:visible="visiblePatrolPointTable"
      :patrolmanLineId="patrolmanLineId"
      v-model:selectedPoint="selectedPoint"
      @addpatrolPoint="addpatrolPoint"
    ></patrolPointTable>
  </el-dialog>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  watch,
  ref,
  watchEffect,
  nextTick,
  onMounted,
} from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { leftListquery } from "@/api/system/region";
import MyMap from "@/components/map/MyMap.vue";
import patrolPointTable from "./patrolPointTable.vue";
import {
  userSave,
  patrolmanInfo,
  relationSelect,
  relationDelete,
  relationSave,
} from "@/api/system/patrol";
import { getDict } from "@/api/constant";
import handleCoordinates from "@/components/map/js/modular/handleCoordinates";
import util from "@util/js";
import _ from "lodash";
export default defineComponent({
  name: "StreetTable",
  components: { MyMap, patrolPointTable },
  props: {
    mapVisible: {
      type: Boolean,
      default: false,
    },
    dialogStatus: {
      type: String,
      default: "1",
    },
    currentNode: {
      type: Object,
      default: () => ({}),
    },
    currentRow: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, context) {
    const state = reactive({
      dialogVisible: false,
      disableds: false,
      mapVisible: false,
      visiblePatrolPointTable: false,
      mapFeatures: "draw-line",
      mapDialogTitle: "绘制巡防区域",
      drawAgainBtn: false,
      colorList: [],
      patrolList: [],
      locationArr: [], //选点划线
      selectedPoint: [], //线绑定的点
      initPointArr: [], //线绑定的点(初始点位，删除用)
      patrolmanLineId: "", //巡防线Id
      activeNum: "",
      tableParams: {
        patrolmanColor: "#188feb", // 巡防展示颜色 ,
        patrolmanCoordinate: "", // 巡防坐标 ,
        patrolmanDescribe: "", // 巡防描述 ,
        patrolmanName: "", // 巡防名称 ,
        patrolmanType: "", // 巡防类型 1:巡防线 2:巡防点 3:巡防圈 ,
        regionId: "", // 区域编号
        spotList: [], // 区域编号
      },
      rules: {
        patrolmanName: [
          {
            required: true,
            message: "请输入巡防名称",
            trigger: "blur",
          },
        ],
        patrolmanColor: [
          {
            required: true,
            message: "请选择路径颜色",
            trigger: "blur",
          },
        ],
        patrolmanType: [
          {
            required: true,
            message: "请选择巡防类型",
          },
        ],
      },
    });
    const refData = toRefs(state);
    const mapRef = ref(null);
    const formRef = ref(null);
    const { setPoint, reversePoint, BaiduToGPS, setVideoPoint } =
      handleCoordinates();
    watchEffect(() => {
      state.dialogVisible = props.mapVisible;
    });

    // 初始化
    const initForm = async () => {
      if (props.dialogStatus == "1") {
        state.tableParams.regionId = props.currentNode.id;
      } else if (props.dialogStatus == "2" || props.dialogStatus == "3") {
        const res = await patrolmanInfo({ id: props.currentRow.patrolmanId });
        state.tableParams = res.data;
        state.tableParams.patrolmanCoordinate = JSON.parse(
          res.data.patrolmanCoordinate
        );
        setTimeout(() => {
          drawPartolInfo(state.tableParams);
        }, 200);
        state.activeNum = state.tableParams.patrolmanType;
        getRelationSelect(props.currentRow.patrolmanId);
      }
    };

    onMounted(() => {
      initForm();
    });

    // 获取数据字典
    const queryMenuType = async () => {
      const resCarColor = await getDict("car_card_color");
      const resPatrol = await getDict("zaxf_patrolman_type");
      state.colorList = resCarColor.dict;
      state.patrolList = resPatrol.dict;
    };
    queryMenuType();
    const getPatrolmanType = async (val) => {
      state.tableParams.patrolmanType = val;
      state.activeNum = val;
      state.drawAgainBtn = true;
      if (val === "1") {
        mapRef.value && mapRef.value.clickDrawArea("LineString");
        mapRef.value && mapRef.value.cancelClickMap();
        state.tableParams.patrolmanCoordinate = [];
        if (state.locationArr.length == 0) {
          mapRef.value && mapRef.value.clearPoint();
        }
      } else if (val === "2") {
        mapRef.value && mapRef.value.clearPoint();
        mapRef.value && mapRef.value.getPointClick();
        mapRef.value && mapRef.value.opertionBack();
        state.tableParams.patrolmanCoordinate = [];
        state.locationArr = [];
      }
    };
    // 渲染巡防路径
    const drawPartolInfo = (lineObj) => {
      if (lineObj.patrolmanType == "1") {
        let polyline = lineObj.patrolmanCoordinate[0].map((element, index) => {
          return {
            name: "",
            id: index,
            poiType: 3408,
            // showMovePoint: false,
            showType: 3,
            info: {
              color: lineObj.patrolmanColor,
              width: 12,
            },
            location: setVideoPoint([Number(element[0]), Number(element[1])]),
            click: (e) => {},
          };
        });
        mapRef.value && mapRef.value.mapLineArrow(polyline);
      } else if (lineObj.patrolmanType == "2") {
        const pointInfo = {
          name: lineObj.patrolmanName,
          id: lineObj.patrolmanId,
          type: 1,
          // poiType: typeValue,
          showType: 3,
          location: lineObj.patrolmanCoordinate,
          info: lineObj,
          click: (e) => {},
        };
        nextTick(() => {
          mapRef.value && mapRef.value.loadMarker([pointInfo]);
          mapRef.value &&
            mapRef.value.mapLocation(lineObj.patrolmanCoordinate, 14);
        });
        // data.patrolPointList.push(pointInfo);
      }
    };
    // 绘制区域回调
    const drawArea = (corrdinates) => {
      state.drawAgainBtn = false;
      state.tableParams.patrolmanCoordinate = corrdinates.map((item) => {
        return item.map((it) => {
          return reversePoint(it);
        });
      });
    };
    // 点击地图
    const clickMap = (e, point) => {
      state.drawAgainBtn = false;
      state.tableParams.patrolmanCoordinate = point;
    };
    // 巡防点列表
    const getPointTable = () => {
      state.visiblePatrolPointTable = true;
    };
    // 地图添加寻访点
    const addpatrolPoint = (locationArr) => {
      console.log(locationArr);
      state.locationArr = locationArr;
      mapRef.value && mapRef.value.clearPoint();
      setTimeout(() => {
        locationArr.forEach((item) => {
          if (item.patrolmanCoordinate) {
            const location = JSON.parse(item.patrolmanCoordinate);
            const pointInfo = {
              name: `${item.patrolmanName}\n${item.signPointDict}`,
              id: item.patrolmanId,
              type: 1,
              showType: 3,
              // poiType: 3418,
              location: location,
              info: item,
              click: (e) => {},
            };
            nextTick(() => {
              mapRef.value && mapRef.value.loadMarker([pointInfo]);
            });
            state.tableParams.spotList = state.locationArr.map((item) => {
              let obj = {
                patrolmanSpotId: item.patrolmanId,
                signPoint: item.signPoint,
              };
              return obj;
            });
          }
        });
      }, 500);
    };

    // 保存地图点位
    const saveMapPoint = async (formEl) => {
      // 绘制区域
      if (!formEl) return;
      formEl.validate(async (valid) => {
        if (valid) {
          const form = _.cloneDeep(state.tableParams);
          if (form.patrolmanType == "1") {
            if (form.patrolmanCoordinate.length == 0) {
              ElMessage.warning("请添加巡防路径或巡防点");
              return;
            } else if (form.patrolmanCoordinate.length > 1) {
              ElMessage.warning("请保留一条巡防信息");
              return;
            }
            //百度坐标转GPS坐标
            let coord = form.patrolmanCoordinate[0].map((item) => {
              return BaiduToGPS(item);
            });
            form.patrolmanCoordinate = [coord];
          }
          form.patrolmanCoordinate = JSON.stringify(form.patrolmanCoordinate);
          const res = await userSave(form);
          if (res.code == 0) {
            ElMessage.success("添加成功");
            if (state.patrolmanLineId) {
              updataPatrolPoint();
            }
          }
          context.emit("patrolSubmit");
          mapDialogClose();
        } else {
          return false;
        }
      });
    };
    // 地图弹框关闭回调
    const mapDialogClose = (formRef) => {
      state.tableParams = null;
      mapRef.value && mapRef.value.resetMap();
      context.emit("update:mapVisible", false);
    };
    //获取巡防线绑定的巡防点
    const getRelationSelect = async (id) => {
      const param = {
        patrolmanLineId: id,
        isPage: false,
      };
      const res = await relationSelect(param);
      if (res.code == 0) {
        const list = res.page.list.map((item) => {
          if (item.signPoint == "1") {
            item.signPointDict = "必巡";
          } else {
            item.signPointDict = "非必巡";
          }
          return item;
        });
        state.patrolmanLineId = id;
        state.selectedPoint = list;
        state.initPointArr = list;
        addpatrolPoint(list);
      }
    };
    const updataPatrolPoint = async () => {
      const params = {
        patrolmanLineId: state.patrolmanLineId,
        spotList: state.initPointArr.map((val) => {
          return {
            patrolmanSpotId: val.patrolmanId,
            signPoint: val.signPoint,
          };
        }),
      };
      const resDel = await relationDelete(params);

      const param = {
        patrolmanLineId: state.patrolmanLineId,
        spotList: state.selectedPoint.map((val) => {
          return {
            patrolmanSpotId: val.patrolmanId,
            signPoint: val.signPoint,
          };
        }),
      };
      const resSave = await relationSave(param);
    };
    return {
      ...refData,
      formRef,
      mapRef,
      getPatrolmanType,
      drawArea,
      clickMap,
      saveMapPoint,
      mapDialogClose,
      getPointTable,
      addpatrolPoint,
    };
  },
});
</script>
<style lang="scss" scoped>
.activeStyle {
  background-color: #1890ff;
  color: #fff;
}
.map-box {
  width: 100%;
  height: 50vh;
}
.colorItem {
  @include flex-row-sb-c;
  .carColor {
    width: 16px;
    height: 16px;
  }
}
</style>
